import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom"; // Import useNavigate for back navigation
import "./NotificationPage.css"; // Import the CSS file

const NotificationPage = ({ notifications }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous page
  };

  return (
    <div className="notification-page">
      <div className="top-bar-noti">
        <button className="back-button" onClick={handleBackClick}>
          &lt; Back
        </button>
        <h1 className="top-heading">Notifications</h1>
      </div>
      {notifications && notifications.length > 0 ? (
        <ul className="notification-list">
          {notifications.map((notification, index) => (
            <li key={index} className="notification-item">
              <div className="notification-box">
                <strong>{notification.title || "Notification"}</strong>
                <p>{notification.message}</p>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p style={{marginTop:'60px'}}>No notifications available.</p>
      )}
    </div>
  );
};

NotificationPage.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      message: PropTypes.string,
    })
  ).isRequired,
};

export default NotificationPage;
